angular.module('capability-ng-academic-planner').component('blockedSuggestionsListing', {
  bindings: {
    suggestionList: '<',
    iconTheme: '@',
    icon: '@',
    suggestionTypeText: '@'
  },
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_suggestions_listing/blocked_suggestions_listing.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_suggestions_listing/blocked_suggestions_listing.ts